/**
 * Browser detection utilities
 */

/**
 * Minimum supported browser versions
 */
export const MIN_BROWSER_VERSIONS = {
    CHROME: 92,
    FIREFOX: 90,
    SAFARI: 15.4,
};

/**
 * Check if the current browser is supported
 * @returns true if the browser is supported, false otherwise
 */
export function isSupportedBrowser(): boolean {
    const ua = navigator.userAgent;

    // Check for Internet Explorer
    if (/MSIE|Trident/.test(ua)) {
        return false;
    }

    // Check for Edge Legacy (EdgeHTML)
    if (/Edge\/\d+/.test(ua) && !/Edg\/\d+/.test(ua)) {
        return false;
    }

    // Check for old Chrome versions
    const chromeMatch = ua.match(/Chrome\/(\d+)/);
    if (chromeMatch && parseInt(chromeMatch[1], 10) < MIN_BROWSER_VERSIONS.CHROME) {
        return false;
    }

    // Check for old Firefox versions
    const firefoxMatch = ua.match(/Firefox\/(\d+)/);
    if (firefoxMatch && parseInt(firefoxMatch[1], 10) < MIN_BROWSER_VERSIONS.FIREFOX) {
        return false;
    }

    // Check for old Safari versions
    const safariMatch = ua.match(/Version\/(\d+\.\d+).*Safari/);
    if (safariMatch && parseFloat(safariMatch[1]) < MIN_BROWSER_VERSIONS.SAFARI) {
        return false;
    }

    // Add additional browser checks as needed

    return true;
}

/**
 * Redirects to the unsupported browser page if the browser is not supported
 * @returns true if redirect happened, false otherwise
 */
export function redirectIfUnsupportedBrowser(): boolean {
    if (!isSupportedBrowser()) {
        // Only redirect if not already on the not-supported page
        if (!window.location.pathname.includes('/not-supported')) {
            window.location.href = '/not-supported';
            return true;
        }
    }
    return false;
}
